module.exports = __webpack_public_path__ + "static/media/apti_offered_nyspffa.67084e58.png";